import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../contexts/authentication/AuthenticationContext";
import { Environment } from "../../../defines/common";
import {
  ALL_MENU_ITEMS,
  DASHBOARD_MENU_ITEM,
  MENU_BUSINESS_USER,
} from "../../../defines/menu-items";
import { ROUTE_PATH_VALUES, RoutePath } from "../../../defines/route-path";
import { MenuContentItem } from "./MenuItem";
import { Role } from "../../../core/models/User";

const MenuContent = () => {
  const { userInfo } = useAuthContext();
  const isBusinessUser = userInfo?.permissionRole === Role.Business;

  const [currentRoutePath, setCurrentRoutePath] = useState<RoutePath>();
  const navigate = useNavigate();
  const location = useLocation();
  const showDashboard = [Environment.Preprod, Environment.Prod].includes(
    window.ENV_ENVIRONMENT
  );
  const baseItems = isBusinessUser ? MENU_BUSINESS_USER : ALL_MENU_ITEMS;
  const menuItems = showDashboard
    ? [DASHBOARD_MENU_ITEM].concat(baseItems)
    : baseItems;

  useEffect(() => {
    const currentPath = location.pathname;
    const routePath = ROUTE_PATH_VALUES.find(
      (value) => currentPath.startsWith(value) && value !== RoutePath.HOME
    );
    setCurrentRoutePath(routePath);
  }, [location]);

  const handleListItemClick = (route: RoutePath) => {
    navigate(route);
  };

  return (
    <Box className="space-y-[0.625rem]" aria-label="menu content">
      {menuItems?.map((item) => {
        return (
          <MenuContentItem
            key={item.id}
            item={item}
            selected={item.route.startsWith(currentRoutePath!)}
            onClick={handleListItemClick}
          />
        );
      })}
    </Box>
  );
};

export { MenuContent };
